import { create } from 'zustand';

export type PanelTab = 'evidence' | 'data' | 'sql' | 'trace' | 'context';

/** Which answer's panel is open, and on which tab (#1507, flag on). One panel at a time; nothing is persisted. */
interface ResultPanelState {
  open: { owner: string; tab: PanelTab } | null;
  openPanel: (owner: string, tab: PanelTab) => void;
  closePanel: (owner?: string) => void;
}

export const useResultPanel = create<ResultPanelState>((set, get) => ({
  open: null,
  openPanel: (owner, tab) => set({ open: { owner, tab } }),
  // a named owner closes only its own panel, so an answer leaving the screen never closes another's
  closePanel: (owner) => { if (!owner || get().open?.owner === owner) set({ open: null }); },
}));
